const { gsap } = require('gsap');
import { ScrollTrigger } from "gsap/ScrollTrigger";
import _ from "lodash";

const windowScrollPage = function() {

    //-> header small header
    const scrollHeader = () => {
        ScrollTrigger.create({
            start: 'top 30%',
            end: 99999,
            toggleClass: { className: 'scrolling', targets: '#header' },
            // markers : true
        });

    }

    //-> parallax webdoor
    const parallaxWebdoor = function(el) {

        gsap.fromTo($(el).not(".no-plx").find('picture'), {
            yPercent: 0,
            scale: 1,
        }, {
            yPercent: -35,
            scale: 1.6,
            ease: "none",
            scrollTrigger: {
                trigger: el,
                start: "center 40%",
                end: "bottom -=50%",
                scrub: true,
            }
        });
    }
    
    //-> parallax webdoor
    const icoMeffect = function(el) {

        const elm = $("#ico-m-effect");

        gsap.fromTo(elm, {
            xPercent: -2000,
            // autoAlpha:0,
        }, {
            xPercent: 0,
            // autoAlpha:1,
            ease: "none",
            scrollTrigger: {
                trigger: elm,
                start: "center bottom",
                end: "140% 90%",
                scrub: 2,
                // markers:true
            }
        });
    }

    // -> big number
    const bigNumber = function () {
        gsap.utils.toArray(".anim-big-numb").forEach((elm, i) => {

            gsap.fromTo(elm, {
                y: 0
            }, {
                scrollTrigger: {
                    trigger: elm,
                    start: '20% center',
                    end: 'center top',
                    scrub: true,
                    invalidateOnRefresh: true,
                    // markers : true
                },
                y: -500,
                ease: "none",
            });
        });
    }

    //-> bg transition scroll View
    const bgTransitionInView = (classBg) => {
        const bgChange = gsap.utils.toArray(classBg);
        bgChange.forEach((bgs) => {
            gsap.from(bgs, {
                scrollTrigger: {
                    start: 'top 65%',
                    end: 'bottom top',
                    trigger: bgs,
                    toggleClass: 'in-view'
                }
            });
        });
    }

    //-> fade-In Element in scroll View
    const showFade = (classFade) => {
        const bgChange = gsap.utils.toArray(classFade);
        bgChange.forEach((elmFade) => {
            gsap.from(elmFade, {
                scrollTrigger: {
                    start: 'top 65%',
                    end: '+=100%',
                    trigger: elmFade,
                    toggleClass: 'in-view',
                    // markers : true
                }
            });
        });
    }

    //-> Left top Right in scroll View
    const showLefttoRight = (classFade) => {
        const bgChange = gsap.utils.toArray(classFade);
        bgChange.forEach((elmFade) => {
            gsap.from(elmFade, {
                scrollTrigger: {
                    start: 'top 65%',
                    end: '200% top',
                    trigger: elmFade,
                    toggleClass: 'in-view',
                    // markers: true
                }
            });
        });
    }
    

    const showToptoDown = (classFade) => {
        const bgChange = gsap.utils.toArray(classFade);
        bgChange.forEach((elmFade) => {
            gsap.from(elmFade, {
                scrollTrigger: {
                    start: 'top 80%',
                    end: '200% top',
                    trigger: elmFade,
                    toggleClass: 'in-view',
                    // markers: true
                }
            });
        });
    }

    //-> Right top Left in scroll View
    const showRighttoLeft = (classFade) => {
        const bgChange = gsap.utils.toArray(classFade);
        bgChange.forEach((elmFade) => {
            gsap.from(elmFade, {
                scrollTrigger: {
                    start: 'top 65%',
                    end: 'bottom top',
                    // end: '+=100%',
                    trigger: elmFade,
                    toggleClass: 'in-view',
                    // markers : true
                }
            });
        });
    }

    //-> Right top Left in scroll View
    const showLabelsComo = () => {
        gsap.from("#wrap-labels-como", {
            scrollTrigger: {
                start: 'top 65%',
                end: 'bottom top',
                // end: '+=100%',
                trigger: "#wrap-labels-como",
                toggleClass: 'in-view',
                // markers : true
            }
        });
    }

    //-> layer image in scroll View
    const layerImg = (classLImg, classIText) => {
        const bgChange = gsap.utils.toArray(classLImg);
        bgChange.forEach((classLImg) => {
            gsap.from(classLImg, {
                scrollTrigger: {
                    start: 'top center',
                    //end: '+=100%',
                    trigger: classLImg,
                    toggleClass: 'in-view',
                    // markers : true
                }
            });
            const introText = gsap.utils.toArray(classIText);
            introText.forEach((intTxt) => {
                gsap.from(intTxt, {
                    scrollTrigger: {
                        start: 'center 80%',
                        end: '+=100%',
                        trigger: intTxt,
                        toggleClass: 'in-view',
                        // markers : true
                    }
                });
            });
        });
    }

    //-> text show in scroll View
    const introText = (classIText) => {
        /* const bgChange = gsap.utils.toArray(classIText);
        bgChange.forEach((classIText) => {
        	gsap.from(classIText, {
        		scrollTrigger: {
        			start: 'top center',
        			end: '+=100%',
        			trigger: classIText,
        			toggleClass: 'in-view',
        			// markers : true
        		}
        	});
        }); */
    }

    const plxImage = () => {
        gsap.utils.toArray(".wrap-img-parallax img").forEach((section, i) => {

            const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;

            gsap.fromTo(section, {
                y: -heightDiff
            }, {
                scrollTrigger: {
                    trigger: section.parentElement,
                    scrub: true,
                    invalidateOnRefresh: true
                },
                y: 0,
                ease: "none"
            });
        });
    }

    const elmToScroll = function(el) {
        var _this = el.attr('data-scrollto');
        console.log(_this);

        // if($(window).width() < 1000) {
        //     $("#nav-header, #bt-menu-mobile").removeClass('motion-in');
        // }
        scrollToElm(_this);


    }

    const scrollToElm = function(target) {
        var offSTop = 123;//document.getElementById('header').clientHeight;

        gsap.to(window, {
            duration: 2,
            scrollTo: { y: $(target).offset().top - ($(window).width() > 768 ? offSTop : offSTop) }, //scrollTo end bracket
            delay: 0,
            ease: 'Power4.easeInOut'
        });
        // gsap.to(window, {
        //     duration: 1,
        //     scrollTo: document.querySelector(target).offsetTop , //- document.querySelector('header').clientHeight
        //     ease: 'Expo.easeOut',
        // }
        //);
    }

    return {
        init: () => {

            scrollHeader();

            if ($(".webdoor").length > 0)
                parallaxWebdoor(".webdoor");
            
            if ($(".anim-big-numb").length > 0)
                bigNumber();

            if ($(".wrap-img-parallax").length > 0)
                plxImage();

            if($("#ico-m-effect").length > 0)
                icoMeffect();

            if ($('.bg-transition').length > 0)
                bgTransitionInView('.bg-transition');

            if ($('.showFade').length > 0)
                showFade('.showFade');

            if ($('.slideLeftToRight').length > 0)
                showLefttoRight('.slideLeftToRight');

            if ($('.slideRightToLeft').length > 0)
                showRighttoLeft('.slideRightToLeft');
            
            if ($('.showToptoDown').length > 0)
                showToptoDown('.showToptoDown');

            if ($('.label-numb').length > 0)
                showLabelsComo('.label-numb');

            if ($('.wrap-picture-img-parallax').length > 0)
                layerImg('.wrap-picture-img-parallax', '.text-intro');

            $(document).on('click', '[data-scrollto]', function(e) {
                e.preventDefault();
                elmToScroll($(this));
            });


        }
    }

}();

export default windowScrollPage;